import React, { useEffect } from 'react';
import { useAppSelector } from '../hooks/redux';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useAppSelector((state) => state.preferences);

  useEffect(() => {
    // Apply theme to HTML element
    const html = document.documentElement;
    if (theme === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  }, [theme]);

  return <>{children}</>;
} 